"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultBasketContext = void 0;
var _basketItem = require("@ori/basket-item");
const defaultBasketContext = exports.defaultBasketContext = {
  addedFree: [],
  addedPaid: [],
  atpClusterId: undefined,
  backorderItems: [],
  basketItemTranslations: _basketItem.basketItemDefaultTranslations,
  basketItemTranslationsNamespace: '',
  basketOffers: [],
  consumerOrders: undefined,
  distinctOffers: [],
  isAnonymous: true,
  isConsultant: false,
  isDiscounted: false,
  isEmptyBasket: true,
  message: undefined,
  shippingOffer: undefined,
  shoppingBag: undefined,
  shoppingBagItems: [],
  shoppingBagItemsValid: [],
  shoppingMessages: [],
  shouldMutateCombineSection: false,
  showBannerSection: false,
  showBpGlobally: false,
  subscriptions: [],
  vipLoyalty: null,
  vouchers: [],
  setShouldMutateCombineSection: () => {},
  setIsLoadingAdditionalData: () => {}
};